import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useContext } from "react";
import MainContext from "../../context/mainContext";
import { getfreetrialApi } from "../../services/authApi"
import { toast } from "react-toastify";
import {
  checkErrorMessage,
  checkResponseData
} from "../../components/pages/utils/utilsFunctions";

export default function GetFreeTrialDict(props) {
  const { openGetFreeTrialDict, handleGetFreeTrialDict, trailDict, handleFullScreen } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const { handleUserType, userTypes, handlePageNumber } = useContext(MainContext);


  const getfreetrialFromBack = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const response = await getfreetrialApi(data)
      let resData = checkResponseData(response)
      if (resData["success"]) {
        localStorage.setItem("token", JSON.stringify(resData["token"]));
        let newUserType = ["freetrial_dict", ...userTypes]
        handleUserType(newUserType)
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 2000 });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      console.error("Error-getfreetrialFromBack", error);
    }
  };



  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={openGetFreeTrialDict}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"استفاده از سرویس آزمایشی ترجمه لغت"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            در طرح استفاده آزمایشی رایگان شما به مدت 15 روز می توانید همانند یک کاربر ویژه از خدمات سایت استفاده کنید ،در صورت اتمام مدت 15 روز سرویس دیکشنری به ازای هر زبان به تعداد 15 ترجمه برای شما فعال خواهد ماند
            <br />
            <Button autoFocus
              className='yn-showPackages2 yn-showPackages'
              variant="contained"
              onClick={() => { handlePageNumber("", 2); handleFullScreen.exit(); handleGetFreeTrialDict(false) }}
              color="warning"
              size="small"
              sx={{ mt: 1 }}>
              مشاهده لیست پکیج ها
            </Button>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { handleGetFreeTrialDict(false) }}>
            بستن
          </Button>
          <Button
            className='yn-freeTrial2 yn-freeTrial'
            variant="contained"
            color="info"
            size="small"
            // sx={{ fontSize: 10,mt:0.5 }}
            onClick={() => { getfreetrialFromBack({ typeTrail: "freetrial_dicts", trialService: trailDict }); handleGetFreeTrialDict(false) }}
          >
            دریافت سرویس آزمایشی
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}